import { ListOfWorkstepResponse } from './Api/ListOfWorkstepResponse';

export class WorkstepEntity extends ListOfWorkstepResponse {
	public static tryCast(o: any): WorkstepEntity {
		const ret = new WorkstepEntity();
		return Object.assign(ret, o);
	}
}
